<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> Add/Update Device Model</span>
    </div>
  </div>

  <div class="component-container">
    <form [formGroup]="modelFirmwareForm" novalidate>
      <!-- List Section -->
      <div class="component-header">
        <h6 class="component-title">
          {{
            ModelFirmwareCreate ? 'Create' : ModelFirmwareUpdate ? 'Update' : ''
          }}
          Device Model
        </h6>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <div class="form-section">
          <div class="form-group">
            <label for="modelName" class="form-label">Model Name</label>
            <mat-form-field appearance="outline">
              <mat-label>Model Name</mat-label>
              <input
                matInput
                id="modelName"
                type="text"
                placeholder="Model Name"
                formControlName="modelName"
                required
                [readonly]="ModelFirmwareUpdate"
              />
              @if (
                modelFirmwareForm.controls['modelName'].touched &&
                modelFirmwareForm.controls['modelName'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    modelFirmwareForm.controls['modelName'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-group">
            <label for="modelCode" class="form-label">Model Code</label>
            <mat-form-field appearance="outline">
              <mat-label>Model Code</mat-label>
              <input
                matInput
                id="modelCode"
                type="text"
                placeholder="Model Code"
                formControlName="modelCode"
                required
              />
              @if (
                modelFirmwareForm.controls['modelCode'].touched &&
                modelFirmwareForm.controls['modelCode'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    modelFirmwareForm.controls['modelCode'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-group">
            <label for="hwVersion" class="form-label">HW Version</label>
            <mat-form-field appearance="outline">
              <mat-label>HW Version</mat-label>
              <input
                matInput
                id="hwVersion"
                type="text"
                placeholder="HW Version"
                formControlName="hwVersion"
                required
              />
              @if (
                modelFirmwareForm.controls['hwVersion'].touched &&
                modelFirmwareForm.controls['hwVersion'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    modelFirmwareForm.controls['hwVersion'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        <div class="button-group">
          @if (ModelFirmwareCreate && ModelFirmwarePermissionCreate) {
            <button
              type="button"
              [disabled]="!modelFirmwareForm.valid"
              (click)="validateFormSave()"
              class="submit-button"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          }
          @if (ModelFirmwareUpdate && ModelFirmwarePermissionUpdate) {
            <button
              type="button"
              [disabled]="!modelFirmwareForm.valid"
              (click)="validateFormUpdate()"
              class="edit-button"
            >
              Update <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          }
        </div>
      </div>
    </form>
  </div>
</div>
